import React, { useCallback } from "react";
import { useForm } from "antd/es/form/Form";
import { Button, Col, Row } from "antd";
import { observer } from "mobx-react";
import config from "./config";
import Form from "../../common/forms/form";
import Field from "../../common/forms/field";
import { CANCEL_BUTTON, CHANGE_BUTTON } from "../../../constants/translates";
import ChangePasswordStore from "../../../stores/ChangePasswordStore";

interface Props {
  onFinish: () => void;
}

const store = new ChangePasswordStore();

const gutter = 15;

const CreateDeclarant: React.FC<Props> = ({ onFinish }) => {
  const [form] = useForm();

  const onFinishHandler = useCallback(
    (values: unknown): void => {
      store.changePassword(values as object).finally(() => {
        if (Object.keys(store.errors).length > 0) {
          return;
        }

        form.resetFields();
        onFinish();
      });
    },
    [form, onFinish]
  );

  const onCancelHandler = useCallback(() => {
    form.resetFields();
    onFinish();
  }, [form, onFinish]);

  return (
    <Form
      config={config}
      errors={store.errors as { [key: string]: string[] | null }}
      onFinishHandler={onFinishHandler}
      form={form}
    >
      <Field name="old_password" />
      <Field name="password" />
      <Field name="password_confirmation" />

      <Row gutter={gutter}>
        <Col>
          <Button type="primary" htmlType="submit">
            {CHANGE_BUTTON}
          </Button>
        </Col>
        <Col>
          <Button type="default" htmlType="button" onClick={onCancelHandler}>
            {CANCEL_BUTTON}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default observer(CreateDeclarant);
